module.exports = __webpack_public_path__ + "5fa1b8f25b4aa8787f70d5b6b7f0b90f.ttf";